import { getBadgeValueFromIdentifier } from '@ynap/analytics';

export default (analytics, product, position, pagenumber, useIdentifier) => {
    const { page } = analytics;
    const { masterCategory = {}, name, analyticsAttributes = {}, badge, consideredBadge, price } = product;
    const { nameEN, preOrder, gender, colour, department, season, category } = analyticsAttributes;

    return {
        event: `view product - ${nameEN || name}`,
        eventEffect: 'go to product page',
        category: {
            primaryCategory: page?.category?.primaryCategory,
            subCategory: page?.category?.pageType,
        },
        attributes: {
            productFindingMethod: page?.pageInfo?.pageName,
            position,
            pageNum: pagenumber,
        },
        item: [
            {
                attributes: {
                    productFindingMethod: page?.pageInfo?.pageName,
                    badges: badge?.label ? [useIdentifier ? getBadge(badge) : badge] : [],
                    colour,
                    department,
                    discountPercent: price?.discountPercentage || '0',
                    position,
                    preOrderFlag: preOrder,
                    saleFlag: product?.onSale ? 'on sale' : 'full price',
                    season,
                    stock: analyticsAttributes?.badge?.type === 'STOCK' ? analyticsAttributes.badge.key : 'IN_STOCK',
                    sustainabilityFlag: !!consideredBadge,
                },
                category: {
                    primaryCategory: masterCategory?.labelEN || masterCategory?.label,
                    subCategory1: masterCategory?.child?.labelEN || masterCategory?.child?.label,
                    subCategory2: category?.subCategory2 || masterCategory.child?.child?.labelEN || masterCategory?.child?.child?.label,
                },
                price: {
                    basePrice: price?.originalPrice || price?.finalPrice,
                    discount: price?.discountPercentage || 0,
                    discountPrice: price?.originalPrice ? price?.originalPrice - price?.finalPrice : 0,
                    priceWithDiscountTax: price?.finalPrice,
                    currency: price?.currency?.label,
                    bestPrice: price?.minimumPrice,
                },
                productInfo: {
                    designer: product?.designerName,
                    designerID: product?.designerIdentifier,
                    name: product?.name,
                    productID: product?.partNumber,
                    ...(gender ? { gender } : {}),
                },
            },
        ],
    };
};

export const getBadge = (badge) => ({
    ...badge,
    label: getBadgeValueFromIdentifier(badge.key),
});
